export default __webpack_public_path__ + "static/media/alexa.ffd9d5ea.jpeg";